import React from "react";
import { useTranslation } from "react-i18next";

const LoadingState = ({ dynamicStyles }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50" style={dynamicStyles}>
      <div className="max-w-2xl mx-auto p-4">
        <div className="bg-white shadow-md rounded-lg px-8 pt-6 pb-8 mb-4">
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
          <p className="text-center mt-4">{t("ticket.loading")}</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingState;
